import { Tooltip } from '@postscript/components';
import styled from 'styled-components';

export const StyledTooltip = styled(Tooltip)`
  max-width: 210px;
  white-space: normal;
  font-weight: bold;
`;
